import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { VisuallyHidden, withTracker } from '@andes/common';
import { getPatchedI18n, AndesContext, useId } from '@andes/context';
import { ExpandableSection as ExpandableSection$2, ExpandableSectionContent, ExpandableSectionTrigger as ExpandableSectionTrigger$2 } from '@andes-headless/expandable-section';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { FloatingActionButton } from '@andes/button';
import ChevronDown20 from '@andes/icons/ChevronDown20';
import ChevronUp20 from '@andes/icons/ChevronUp20';
import { Text } from '@andes/typography';
const namespace = 'andes-expandable-section';
const highlightedNamespace = "".concat(namespace, "__highlighted-trigger");
const simpleNamespace = "".concat(namespace, "__simple-trigger");
const ACCENT = '#3483fa';
const DISABLED = 'rgba(0, 0, 0, 0.25)';
const sizes$1 = {
  small: 'small',
  medium: 'large',
  large: 'large'
};
var module$2 = "@andes/expandable-section";
var locale$2 = "en-US";
var translations$2 = {
  "andes-expandable-section\u0004Mostrar contenido": [null, "Show content"],
  "andes-expandable-section\u0004Ocultar contenido": [null, "Hide content"],
  "andes-expandable-section\u0004Mostrar más": [null, "Show more"],
  "andes-expandable-section\u0004Mostrar menos": [null, "Show less"],
  "andes-expandable-section\u0004Expande el texto para usuarios videntes, pero el texto completo ya está disponible para lectores de pantalla": [null, "Expands the full text for sighted users but the full text is already there for screen readers"]
};
var enTranslations = {
  module: module$2,
  locale: locale$2,
  translations: translations$2
};
var module$1 = "@andes/expandable-section";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-expandable-section\u0004Mostrar contenido": [null, "Mostrar contenido"],
  "andes-expandable-section\u0004Ocultar contenido": [null, "Ocultar contenido"],
  "andes-expandable-section\u0004Mostrar más": [null, "Mostrar más"],
  "andes-expandable-section\u0004Mostrar menos": [null, "Mostrar menos"],
  "andes-expandable-section\u0004Expande el texto para usuarios videntes, pero el texto completo ya está disponible para lectores de pantalla": [null, "Expande el texto para usuarios videntes, pero el texto completo ya está disponible para lectores de pantalla"]
};
var esTranslations = {
  module: module$1,
  locale: locale$1,
  translations: translations$1
};
var module = "@andes/expandable-section";
var locale = "pt-BR";
var translations = {
  "andes-expandable-section\u0004Mostrar contenido": [null, "Mostrar conteúdo"],
  "andes-expandable-section\u0004Ocultar contenido": [null, "Ocultar conteúdo"],
  "andes-expandable-section\u0004Mostrar más": [null, "Mostrar mais"],
  "andes-expandable-section\u0004Mostrar menos": [null, "Mostrar menos"],
  "andes-expandable-section\u0004Expande el texto para usuarios videntes, pero el texto completo ya está disponible para lectores de pantalla": [null, "Expande o texto completo para usuários com visão, mas o texto completo já está lá para leitores de tela"]
};
var ptTranslations = {
  module: module,
  locale: locale,
  translations: translations
};
var _ChevronDown, _ChevronUp;
const _excluded$2 = ["behavior", "disabled", "expandedState", "size", "onClick"];
const HighlightedTrigger = /*#__PURE__*/function () {
  const HighlightedTrigger = _ref => {
    let {
        behavior,
        disabled,
        expandedState,
        size,
        onClick
      } = _ref,
      headlessProps = _objectWithoutProperties(_ref, _excluded$2);
    const componentClassNames = classNames(highlightedNamespace, "".concat(highlightedNamespace, "--size-").concat(sizes$1[size]));
    const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
    const showMore = behavior === 'contract' && expandedState === 'collapsed' || behavior === 'expand' && expandedState !== 'expanded';
    const renderedIcon = showMore ? _ChevronDown || (_ChevronDown = /*#__PURE__*/_jsx(ChevronDown20, {
      color: ACCENT
    })) : _ChevronUp || (_ChevronUp = /*#__PURE__*/_jsx(ChevronUp20, {
      color: ACCENT
    }));
    const computedSrLabel = showMore ? i18n.pgettext(namespace, 'Mostrar contenido') : i18n.pgettext(namespace, 'Ocultar contenido');
    return /*#__PURE__*/React.createElement(FloatingActionButton, _extends({
      behavior: "collapsed",
      className: componentClassNames,
      disabled: disabled,
      hierarchy: "quiet",
      icon: renderedIcon,
      onClick: onClick,
      size: sizes$1[size],
      srLabel: computedSrLabel
    }, headlessProps));
  };
  HighlightedTrigger.displayName = 'HighlightedTrigger';
  return HighlightedTrigger;
}();
var HighlightedTrigger$1 = HighlightedTrigger;
const colors = {
  plain: 'primary',
  link: 'link'
};
const sizes = {
  small: 's',
  medium: 'm',
  large: 'l'
};
const _excluded$1 = ["behavior", "color", "contractionText", "disabled", "expandedState", "expansionText", "icon", "onClick", "size"];
const SimpleTrigger = /*#__PURE__*/function () {
  const SimpleTrigger = _ref => {
    let {
        behavior,
        color,
        contractionText,
        disabled,
        expandedState,
        expansionText,
        icon,
        onClick,
        size
      } = _ref,
      headlessProps = _objectWithoutProperties(_ref, _excluded$1);
    const componentClassNames = classNames(simpleNamespace, "".concat(simpleNamespace, "--size-").concat(size));
    const computeIconColor = () => {
      if (disabled) return DISABLED;
      return color === 'link' ? ACCENT : undefined;
    };
    const showMore = behavior === 'contract' && expandedState === 'collapsed' || behavior === 'expand' && expandedState !== 'expanded';
    const renderedIcon = showMore ? /*#__PURE__*/_jsx(ChevronDown20, {
      color: computeIconColor()
    }) : /*#__PURE__*/_jsx(ChevronUp20, {
      color: computeIconColor()
    });
    return /*#__PURE__*/React.createElement("button", _extends({
      className: componentClassNames,
      disabled: disabled,
      onClick: onClick
    }, headlessProps), /*#__PURE__*/_jsx(Text, {
      color: disabled ? 'disabled' : colors[color],
      size: sizes[size]
    }, void 0, showMore ? expansionText : contractionText), icon && renderedIcon);
  };
  SimpleTrigger.displayName = 'SimpleTrigger';
  return SimpleTrigger;
}();
var SimpleTrigger$1 = SimpleTrigger;
const ExpandableSectionTrigger = /*#__PURE__*/function () {
  const ExpandableSectionTrigger = _ref => {
    let {
      behavior,
      disabled,
      id,
      highlighted,
      simple,
      size = 'large',
      triggerProps
    } = _ref;
    const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
    const {
      expandedState,
      componentGetterProps: {
        getHeadlessAttributes,
        getTriggerProps
      }
    } = triggerProps;
    const renderTrigger = () => {
      const commonProps = _objectSpread(_objectSpread({
        'aria-describedby': "".concat(id, "-sr-button-disclaimer"),
        behavior,
        disabled,
        expandedState,
        size,
        type: 'button'
      }, getHeadlessAttributes()), getTriggerProps());
      if (highlighted) {
        return /*#__PURE__*/React.createElement(HighlightedTrigger$1, commonProps);
      }
      const {
        color = 'plain',
        icon = true,
        expansionText = i18n.pgettext(namespace, 'Mostrar más'),
        contractionText = i18n.pgettext(namespace, 'Mostrar menos')
      } = simple || {};
      return /*#__PURE__*/React.createElement(SimpleTrigger$1, _extends({
        color: color,
        contractionText: contractionText,
        expansionText: expansionText,
        icon: icon
      }, commonProps));
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger(), /*#__PURE__*/_jsx(VisuallyHidden, {
      id: "".concat(id, "-sr-button-disclaimer")
    }, void 0, i18n.pgettext(namespace, "Expande el texto para usuarios videntes, pero el texto completo ya est\xE1 disponible\n            para lectores de pantalla")));
  };
  ExpandableSectionTrigger.displayName = 'ExpandableSectionTrigger';
  return ExpandableSectionTrigger;
}();
var ExpandableSectionTrigger$1 = ExpandableSectionTrigger;
const _excluded = ["behavior", "children", "className", "defaultHeight", "disabled", "extend", "height", "highlighted", "id", "loadHeight", "simple", "size", "trigger"];
const ExpandableSection = /*#__PURE__*/function () {
  const ExpandableSection = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        behavior = 'expand',
        children,
        className,
        defaultHeight = 300,
        disabled,
        extend = false,
        height,
        highlighted,
        id,
        loadHeight,
        simple,
        size = 'large',
        trigger
      } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    const componentClassNames = classNames(namespace, className);
    const componentId = useId(id);
    const otherTriggerProps = {
      behavior,
      disabled,
      id: componentId,
      highlighted,
      simple,
      size
    };
    return /*#__PURE__*/React.createElement(ExpandableSection$2, _extends({
      behavior: behavior,
      className: componentClassNames,
      defaultHeight: defaultHeight,
      disabled: disabled,
      height: height,
      id: componentId,
      loadHeight: loadHeight,
      ref: ref
    }, otherProps), /*#__PURE__*/_jsx(ExpandableSectionContent, {}, void 0, children), /*#__PURE__*/_jsx(ExpandableSectionTrigger$2, {}, void 0, extend && typeof trigger === 'function' ? trigger : triggerProps => /*#__PURE__*/React.createElement(ExpandableSectionTrigger$1, _extends({
      triggerProps: triggerProps
    }, otherTriggerProps))));
  });
  ExpandableSection.displayName = 'ExpandableSection';
  return ExpandableSection;
}();
var ExpandableSection$1 = withTracker(ExpandableSection, {
  name: 'Expandable-Section'
});
export { ExpandableSection$1 as ExpandableSection };
